module.exports = __webpack_public_path__ + "img/pc_new_bg.1cec4124.png";